import React from 'react';
import { BookOpen, Clock, BarChart } from 'lucide-react';
import Button from '../../../components/ui/Button';

const CourseCard = ({ course }) => {
  return (
    <div className="bg-white rounded-xl shadow-sm overflow-hidden">
      <img
        src={course.image}
        alt={course.title}
        className="w-full h-48 object-cover"
      />
      <div className="p-6">
        <h3 className="font-semibold mb-2">{course.title}</h3>
        <div className="flex items-center space-x-4 text-sm text-gray-600 mb-4">
          <div className="flex items-center">
            <Clock className="h-4 w-4 mr-1" />
            {course.duration}
          </div>
          <div className="flex items-center">
            <BookOpen className="h-4 w-4 mr-1" />
            {course.lessons} lessons
          </div>
        </div>
        
        <div className="mb-4">
          <div className="flex justify-between text-sm mb-1">
            <span>Progress</span>
            <span>{course.progress}%</span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div
              className="bg-indigo-600 rounded-full h-2"
              style={{ width: `${course.progress}%` }}
            />
          </div>
        </div>
        
        <Button className="w-full">Continue Learning</Button>
      </div>
    </div>
  );
};

export default CourseCard;